<template>
  <div class="row dvContent">
    <BodyLoader :loading="firstLoad"></BodyLoader>
    <div class="dvModals">
      <div id="modal-reassign-team" class="modal">
        <div class="dvModalHeader">
          <div class="dvModalHeader-title">
            Reassign
          </div>
          <a class="modal-close waves-effect waves-dark btn-Close flexCenterAll" href="javascript:void(0)"><span class="icon-action_cancel"></span></a>
        </div><!--dvModalHeader-->

        <div class="dvModalContent">
          <form>
            <div class="row">
              <div class="col s12 l12 dvModalContent-field">
                <label class="defaultModal-label">Client</label>
                <input v-model="reassignReferral.name" class="browser-default defaultModal-input" readonly type="text" />
              </div>
              <div class="col s12 l6 dvModalContent-field">
                <label class="defaultModal-label">Channel</label>
                <select class="browser-default defaultModal-input" v-model="reassignReferral.channel_id" @change="onChannelChange()">
                  <option value="" disabled selected>Select from list</option>
                  <option v-for="(channel, index) in defaultChannels" :key="index" :value="channel.id">{{ channel.name }}</option>
                </select>
                <div class="defaultModal-helper-text"></div>
              </div>
              <div class="col s12 l6 dvModalContent-field">
                <label class="defaultModal-label">Team</label>
                <select class="browser-default defaultModal-input" v-model="reassignReferral.team_id" @change="onTeamChange()">
                  <option value="" disabled selected>Select from list</option>
                  <option v-for="(team, index) in getTeams(reassignReferral.channel_id)" :key="index" :value="team.id">{{ team.name }}</option>
                </select>
                <div class="defaultModal-helper-text"></div>
              </div>
              <div class="col s12 l6 dvModalContent-field">
                <label class="defaultModal-label">Member</label>
                <select class="browser-default defaultModal-input" v-model="reassignReferral.user_id">
                  <option value="" disabled selected>Select from list</option>
                  <option v-for="(user, index) in getUsers(reassignReferral.team_id)" :key="index" :value="user.id">{{ user.name }}</option>
                </select>
                <div class="defaultModal-helper-text"></div>
              </div>
            </div>
          </form>
        </div><!--dvModalContent-->
        <div class="dvModalFooter">
          <a
            v-if="!reassignTeam"
            @click="doReassign()"
            href="javascript:void(0)" class="waves-effect waves-light btn btn-Tools btnSubmit flexCenterAll">
            <span class="icon-action_check"></span>Reassign
          </a>

          <a
            v-if="reassignTeam"
            href="javascript:void(0)"
            :class="{ disabled: true }"
            class="waves-effect waves-light btn btn-Tools btnSubmit flexCenterAll">
            Reassigning...
          </a>

          <a
            @click="closeModal('modal-reassign-team')"
            href="javascript:void(0)" class="waves-effect waves-light btn btn-Tools btnCancel flexCenterAll"><span class="icon-action_cancel"></span>Cancel</a>
        </div>
      </div><!-- modal-->


    </div>

    <div class="col dvResultsContentMain">
      <SearchResultNav :q="q"></SearchResultNav>

      <div class="row dvResultsContent">
        <div class="dvResultsBar">
          Found <strong>{{ pager.totalRecords }}</strong> result {{ pager.totalRecords > 1 ? 's' : '' }} for <strong>"{{q}}"</strong> in Clients
        </div><!-- dvResultsBar -->
        <div class="col s12 dvContentMain">
          <div class="dvCards-container">
            <ContentLoader :loading="loading" :firstLoad="firstLoad"></ContentLoader>

            <div
              v-show="noRecordFound && !loading"
              class="dvBlankSection">
              <div class="dvBlankSectionBox flexCenterAll">
                <div class="dvBlankSection-content">
                  <div class="dvBlankSection-icon flexCenterAll"><i class="material-icons">find_in_page</i></div>
                  <div class="dvBlankSection-text-primary center-align">
                    There are no clients to display
                  </div>
                  <div class="dvBlankSection-text-secondary center-align">
                    Try using the search box above to find what you are looking for.
                  </div>
                </div>
              </div>
            </div>


              <div class="row" v-for="(chunk, idx) in referralChunks" :key="idx">
                <div class="col s12 l6" v-for="(referral, index) in chunk" :key="index">
                  <CardViewAdmin
                    v-if="$getConstRole('ROLE_SUB_ADMIN') == $store.getters.getCurrentUserRole"
                    :referral="referral"
                    :idx="index"
                    @processArchive="processArchive"
                    @extendReferral="extendReferral"
                    @confirm="confirm"
                    @showReassignModal="showReassignModal">
                  </CardViewAdmin>

                  <CardView
                    v-if="$getConstRole('ROLE_SUB_ADMIN') != $store.getters.getCurrentUserRole"
                    :referral="referral"
                    :idx="index"
                    @processArchive="processArchive"
                    @extendReferral="extendReferral"
                    @confirm="confirm"
                    @showReassignModal="showReassignModal">
                  </CardView>
                </div>
              </div>


          </div><!-- dvCards-container -->
        </div>
      </div><!--  dvResultsContent forClients -->

    </div> <!-- dvResultsContentMain -->

    <div class="col s12 dvContentTools">
      <div class="dvContentTools-fx"></div>
      <div class="dvContentTools-content">
        <a
          :class="{ disabled: (pager.currentPage < 2 || loading) ? true : false }"
          @click="previousPage()"
          href="javascript:void(0)" class="waves-effect waves-light btn btn-Tools isPagination flexCenterAll">
          <span class="icon-nav_chevron_left"></span>Previous
        </a>
<!--  -->
        <div class="dvContentTools-pagination">
          <form id="frmChangePassword" @submit.prevent="setPage">
            <input
              type="text" class="browser-default" v-model="pager.currentPage" />
          </form>
          <div class="dvContentTools-pagination-label">of {{ pager.totalPages }}</div>
          <!-- <div class="dvContentTools-pagination-label">{{ pager.dataStart }} of {{ pager.totalRecords }}</div> -->
        </div>

        <a
          :class="{ disabled: !pager.hasNext || loading }"
          @click="nextPage()"
          href="javascript:void(0)" class="waves-effect waves-light btn btn-Tools isPagination flexCenterAll">
          Next<span class="icon-nav_chevron_right"></span>
        </a>
      </div>
      <div class="dvContentTools-page">
        <a href="#" class="waves-effect waves-dark btn btn-Tools isSecondary flexCenterAll"><span class="icon-content_email"></span><div class="hide-on-small-only">Email</div></a>
        <a href="#" class="waves-effect waves-dark btn btn-Tools isSecondary flexCenterAll"><span class="icon-action_print"></span><div class="hide-on-small-only">Print</div></a>
        <ToTop></ToTop>
      </div>
    </div>

    <SnackBar :snackbarDetails="snackbarDetails"></SnackBar>
    <ConfirmationDialog
      :dialog="dialog"
      @doConfirm="doConfirm"
      @doCancel="doCancel">
    </ConfirmationDialog>

  </div> <!-- dvContent -->
</template>

<script>
  import BodyLoader from '@/components/BodyLoader.vue'
  import SearchResultNav from './SearchResultNav.vue'
  import CardView from '@/components/referral_view/ClientCardView.vue'
  import CardViewAdmin from '@/components/admin/referrals/ClientCardView.vue'
  import _ from 'lodash'
  import SnackBar from '@/components/snackbar/SnackBar.vue'
  import ConfirmationDialog from '@/components/confirmation_view/ConfirmationDialog.vue'
  import ContentLoader from '@/components/ContentLoader.vue'
  import M from 'materialize-css'
  import ToTop from '@/components/totop/ToTop.vue'

  export default {
    name: 'search-result-clients',
    data: () => ({
      q: '',
      referrals: [],
      filter_by: '',
      dialog: {
        show: false,
        title: '',
        body: '',
        action: '',
        id: ''
      },
      snackbarDetails: {
        color: 'sb-success',
        msg: '',
        show: false
      },
      pager: {
        currentPage: 1,
        perPage: 10,
        hasNext: 0,
        totalRecords: 0,
        totalPages: 0,
        dataStart: 0
      },
      loading: false,
      firstLoad: true,
      noRecordFound: false,
      defaultTeams: [],
      defaultChannels: [],
      defaultUsers: [],
      reassignTeam: false,
      reassignReferral: {
        id: '',
        name: '',
        team_id: '',
        channel_id: '',
        user_id: ''
      },
    }),
    watch: {
      $route (to, from){
        let q = to.query.q
        this.q = q
        this.pager.currentPage = 1
        this.firstLoad = true
        this.search()

      }
    },
    computed: {
      referralChunks(){
        return _.chunk(Object.values(this.referrals), 2);
      }
    },
    methods: {
      onChannelChange (){
        this.reassignReferral.team_id = ''
        this.reassignReferral.user_id = ''
      },
      onTeamChange (){
        this.reassignReferral.user_id = ''
      },
      getTeams (channel_id){
        let teams = this.defaultTeams.filter(team => {
          return team.channel_id == channel_id
        })
        return teams
      },
      getUsers (team_id){
        let users = this.defaultUsers.filter(user => {
          return user.team_id == team_id
        })
        return users
      },
      closeModal (str){
        const elem = document.getElementById(str);
        const instance = M.Modal.init(elem, {dismissible: false});
        instance.close();

        this.printSendTo = ''
      },
      doReassign () {
        if(this.reassignReferral.team_id == ''){
          this.showMessage('The team field is required.', 'sb-failed')
          return false
        }

        if(this.reassignReferral.channel_id == ''){
          this.showMessage('The channel field is required.', 'sb-failed')
          return false
        }

        if(this.reassignReferral.user_id == ''){
          this.showMessage('The member field is required.', 'sb-failed')
          return false
        }

        if(this.reassignTeam){
          return false;
        }
        this.reassignTeam = true
        let self = this

        this.$http.secured.post('/api/referrals/reassign/'+ this.reassignReferral.id + '/' + this.reassignReferral.user_id)
          .then(response => {
            this.search()
            this.showMessage(response.data.message, 'sb-success')
            this.closeModal('modal-reassign-team')
          })
          .catch(error => {
            if (error.response) {
              let errors = error.response.data.messages
              let msg = []
              Object.keys(errors).forEach(key => {
                msg.push(errors[key])
              })
              this.showMessage(msg.join(','), 'sb-failed')

            }else{
              this.showMessage("Something went wrong! Please try again.", 'sb-failed')
            }
          })
          .then(function () {
            self.reassignTeam = false
          })
      },
      showReassignModal (referral) {
        let reassignReferral = {
          id: referral.id,
          name: this.$store.getters.formatFullName(referral.first_name, referral.last_name),
          team_id: referral.team_id,
          channel_id: referral.channel_id,
          user_id: referral.referred_by
        }

        this.reassignReferral = reassignReferral
        this.openModalTeam('modal-reassign-team')
      },
      openModalTeam (str){
        document.querySelectorAll('.tippy-popper').forEach(popper => {
          popper._tippy.hide()
        })

        const elem = document.getElementById(str);
        const instance = M.Modal.init(elem, {dismissible: false});
        instance.open();
      },
      search (){
        if(this.loading){
          return false;
        }

        if(this.q == ''){
          this.showMessage('The keyword field is required.', 'sb-failed')
          return false
        }

        let self = this
        this.loading = true
        this.noRecordFound = false
        this.selected = [];
        this.referrals = [];
        let url = 'api/search/clients?q='+this.q+'&page='+this.pager.currentPage+'&per_page='+this.pager.perPage

        this.$http.plain.get(url)
          .then(response => {

            // let referrals = response.data.referrals
            // for (let i = 0; i < referrals.length; i++){
            //   referrals[i].selected = false
            //   this.referrals.push(referrals[i])
            // }


            this.referrals = response.data.referrals;

            if(this.referrals.length == 0){
              this.noRecordFound = true
            }

            this.pager.hasNext = response.data.pager.has_next_page
            this.pager.totalRecords = response.data.pager.total_records
            this.pager.dataStart = response.data.pager.data_start
            this.pager.totalPages = response.data.pager.total_pages

            if(response.data.redirect_page != 'clients' && !this.$route.query.click){
              this.$router.push({ name: 'search_results', params: { filter_by: response.data.redirect_page } ,query: { q: this.q } })
            }

            // document.getElementById("toFocus").focus();
          })
          .catch(error => {
            this.showMessage(error, 'sb-failed')
          })
          .then(function () {
            self.loading = false
            self.firstLoad = false
            self.$emit('firstLoadDone')
          })
        },
        setPage (){
          // let page = parseInt(this.pager.currentPage)
          // console.log(page)
          // || !Number.isInteger(page)
          if(this.pager.currentPage > this.pager.totalPages || this.pager.currentPage < 1){
            this.pager.currentPage = 1
          }

          this.search();
        },
        previousPage (){
          window.scroll(0, 0)
          this.pager.currentPage--;
          this.search();
        },
        nextPage (){
          window.scroll(0, 0)
          this.pager.currentPage++;
          this.search();
        },
        showMessage(msg, color){
          this.snackbarDetails = {
            color: color,
            msg: msg,
            show: true
          }
        },
        confirm (action){
          document.querySelectorAll('.tippy-popper').forEach(popper => {
            popper._tippy.hide()
          })

          if(action.type == 'archive'){
            this.dialog = {
              show: true,
              title: 'Are you sure you want to archive '+action.client+'?',
              body: 'You can\'t undo this action.',
              icon: 'icon-action_archive',
              positionBtn: 'Archive',
              negativeBtn: 'Cancel',
              actionType: action.type,
              id: action.id
            }
          }else if(action.type== 'extend-referral'){
            this.dialog = {
              show: true,
              title: 'Do you want to extend referral?',
              body: 'You have '+action.available_extended+' extension/s left',
              icon: 'icon-action_refresh',
              positionBtn: 'Extend',
              negativeBtn: 'Cancel',
              actionType: action.type,
              id: action.id
            }
          }else if(action.type== 'extend-referrals'){
            this.dialog = {
              show: true,
              title: 'Do you want to extend referrals?',
              body: 'Extend all selected referrals?',
              icon: 'icon-action_refresh',
              positionBtn: 'Extend',
              negativeBtn: 'Cancel',
              actionType: action.type,
              id: action.id
            }
          }else if(action.type == 'archives'){
            this.dialog = {
              show: true,
              title: 'Are you sure you want to archive all selected clients?',
              body: 'You can\'t undo this action.',
              icon: 'icon-action_archive',
              positionBtn: 'Archive',
              negativeBtn: 'Cancel',
              actionType: action.type,
              id: action.id
            }
          }else if(action.type == 'verify-referral'){
            this.dialog = {
              show: true,
              title: 'Please verify the data imported from the old CRS',
              body: '',
              icon: 'icon-action_check_circle',
              positionBtn: 'Verify',
              negativeBtn: 'Cancel',
              negativeBtnWithAction: true,
              actionType: action.type,
              id: action.id
            }
          }

        },
        doCancel (){
          if(this.dialog.actionType == 'verify-referral'){
            this.$router.push({ name: 'referrals_update_client', params: { id: this.dialog.id } })
          }
        },
        doConfirm (){
          this.dialog.show = false

          if(this.dialog.actionType == 'archive'){
            this.processArchive(this.dialog.id)
          }else if(this.dialog.actionType == 'extend-referral'){
            this.extendReferral(this.dialog.id)
          }else if(this.dialog.actionType == 'extend-referrals'){
            this.extendReferrals()
          }else if(this.dialog.actionType == 'archives'){
            this.archiveSelected()
          }else if(this.dialog.actionType == 'verify-referral'){
            this.$router.push({ name: 'referrals_client_view', params: { id: this.dialog.id }, query: { verified: 'yes' } })
          }
        },
        processArchives (ids) {
          if(this.archiving){
            return false;
          }
          this.archiving = true
          let self = this

          let url = 'api/referrals/archive/'

          if (this.$getConstRole('ROLE_SUB_ADMIN') == this.$store.getters.getCurrentUserRole){
            url+= ids.id + '?team_id='+ ids.team_id
          }else{
            url+= ids
          }

          this.$http.secured.post(url)
            .then(response => {
              this.search()
              this.showMessage(response.data.message, 'sb-success')
            })
            .catch(error => {
              this.showMessage(error, 'sb-failed')
            })
            .then(function () {
              self.archiving = false
            })
        },
        processArchive (id) {
          this.processArchives(id)
        },
        archiveSelected (){
          if(this.selected.length == 0){
            this.showMessage('No selected referrals', 'sb-default')
            return false;
          }

          this.processArchives(this.selected)
        },
        extendReferral (id){
          this.processExtendReferrals(id)
        },
        processExtendReferrals (ids){
          if(this.extending){
            return false;
          }

          this.extending = true
          let self = this

          let url = 'api/referrals/extend/'

          if (this.$getConstRole('ROLE_SUB_ADMIN') == this.$store.getters.getCurrentUserRole){
            url+= ids.id + '?team_id='+ ids.team_id
          }else{
            url+= ids
          }

          this.$http.secured.post(url)
            .then(response => {
              this.search()
              this.showMessage(response.data.message, 'sb-success')
            })
            .catch(error => {
              if (error.response) {
                this.showMessage(error.response.data.messages.error, 'sb-failed')
              }else{
                this.showMessage("Something went wrong! Please try again.", 'sb-failed')
              }
            })
            .then(function () {
              self.extending = false
              self.selected = []
            })
        },
        extendReferrals (){
          if(this.selected.length == 0){
            this.showMessage('No selected referrals', 'sb-default')
            return false;
          }

          this.processExtendReferrals(this.selected)
        },
        extendSelectedReferral (){
          if(this.selected.length == 0){
            this.showMessage('No selected referrals', 'sb-default')
            return false;
          }

        },
        getDefaultData () {
          this.$http.plain.get('api/default-data')
            .then(response => {
              this.defaultChannels = response.data.channels
              this.defaultTeams = response.data.teams
              this.defaultUsers = response.data.users
            })
            .catch(error => {
              console.log(error);
            })
        }
    },
    mounted() {
      this.q = this.$route.query.q
      this.search()

      if(this.$getConstRole('ROLE_SUB_ADMIN') == this.$store.getters.getCurrentUserRole){
        this.getDefaultData()
      }

    },
    components: {
      CardView,
      CardViewAdmin,
      SnackBar,
      ConfirmationDialog,
      ContentLoader,
      SearchResultNav,
      BodyLoader,
      ToTop
    }
  }
</script>
